export const JOB_INSTANCES = Object.freeze({
  0: {
    label: 'ended',
    color: '#EBFAF6',
    textColor: '#1A6551',

    show: true,
  },
  1: {
    label: 'created',
    color: '#EDF2F7',
    textColor: '#123862',

    show: false,
  },
  2: {
    label: 'inprogress',
    color: '#FEF6E7',
    textColor: '#B0760B',

    show: true,
  },
});
export const JOB_INSTANCES_STATS = Object.freeze({
  0: {
    label: 'ended',
    color: '#38CCA3',
  },
  1: {
    label: 'created',
    color: '#376A9E',
  },
  2: {
    label: 'inprogress',
    color: '#F7CB79',
  },
});

export const WORKING_LOCATIONS = Object.freeze({
  0: {
    status: 'inactive',
    color: '#EDF2F7',
  },
  1: {
    status: 'inprogress',
    color: '#FEF6E7',
  },
  2: {
    status: 'ended',
    color: '#EBFAF6',
  },
});

export const SETTLEMENT_STATUS = Object.freeze({
  1: {
    label: 'under_issuance',
    color: '#FDF4E2',
    textColor: '#4C3305',
  },
  2: {
    label: 'issued',
    color: '#E9F3FF',
    textColor: '#050E19',
  },
  3: {
    label: 'paid',
    color: '#114234',
    textColor: '#E7F9F4',
  },
});

export enum APPROVAL_STATUS {
  PENDING = 1,
  APPROVED,
  REJECTED,
  EDITED_AND_APPROVED,
  REJECTED_AND_PENDING,
  EDITED_AND_PENDING,
}

export const APPROVAL_STATUS_LABELS: Record<APPROVAL_STATUS, string> = {
  [APPROVAL_STATUS.PENDING]: 'pending',
  [APPROVAL_STATUS.APPROVED]: 'approved',
  [APPROVAL_STATUS.REJECTED]: 'rejected',
  [APPROVAL_STATUS.EDITED_AND_APPROVED]: 'edited_and_approved',
  [APPROVAL_STATUS.REJECTED_AND_PENDING]: 'rejected_and_pending',
  [APPROVAL_STATUS.EDITED_AND_PENDING]: 'edited_and_pending',
};
